import * as z from "zod";
import type { ContextualFlatTeamSettingKey } from "./catalog";

/** Compile-pinned to the catalog: a key here with no catalog entry is a type
 *  error, and vice versa. */
export const ContextualFlatTeamSettingsShape = {
  "contextual/enabled": z.boolean().nullish(),
  "contextual/visible": z.boolean().nullish(),
  "contextual/contextualMerchantId": z.string().nullish(),
  "contextual/ctxDomain": z.string().nullish(),
  "contextual/cloudflareHostnameId": z.string().nullish(),
  "contextual/onboardingCompleted": z.boolean().nullish(),
  "contextual/gtmContainerId": z.string().nullish(),
  "contextual/pixelVerified": z.boolean().nullish(),
  "contextual/subdomainActive": z.boolean().nullish(),
} as const satisfies Record<ContextualFlatTeamSettingKey, z.ZodTypeAny>;

export const ContextualFlatTeamSettingsSchema = z.object(
  ContextualFlatTeamSettingsShape,
);
